module.exports = __webpack_public_path__ + "static/media/aragon.cb28e324.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/aragon.svg
// module id = 1139
// module chunks = 0